const simplify = require('simplify-geometry');
const verifyCoordinates = (coordinates = [], processedCoordinates = [], reduction) => {
    if (processedCoordinates.length >= 4) {
        return processedCoordinates;
    }
    const nextProcessedCoordinates = simplify(coordinates, reduction);
    const nextReduction = reduction / 10;
    return verifyCoordinates(coordinates, nextProcessedCoordinates, nextReduction);
};
const composePolygons = (entities, type, reduction) => {
    if (type === 'Polygon') {
        const simplified = verifyCoordinates(entities, [], reduction);
        return simplified;
    }
    return entities.map((entity) => verifyCoordinates(entity, [], reduction));
};
export const simplifyGeometry = (geometry, reduction = 0.0005) => {
    if (!geometry) {
        throw new Error('simplifyGeometry: No geometry had been provided.');
    }
    if (geometry && !geometry.coordinates) {
        throw new Error('simplifyGeometry: No coordinates had been provided.');
    }
    const coordinates = geometry.coordinates.map((coordinate) => {
        return composePolygons(coordinate, geometry.type, reduction);
    }) || geometry.coordinates;
    return {
        ...geometry,
        coordinates,
    };
};
//# sourceMappingURL=simplifyGeometry.js.map